import { FC, PropsWithChildren } from 'react';

import { t } from 'state/intl/translations';

import {
  Container,
  ContentContainer,
  ItemContainer,
  ItemIconContainer,
  ItemText,
  ItemsContainer,
  ItemsSection,
  SectionTitle,
  StyledIcon,
  StyledImage,
  Title,
} from './styled';

const walmartMembershipImg = require('./royal-perks-shot.png');

export const WalmartRoyalPerksMember: FC<PropsWithChildren<{}>> = () => {
  return (
    <>
      <SectionTitle>{t('notARoyalPerksMember')}</SectionTitle>
      <Container>
        <StyledImage source={walmartMembershipImg} />
        <ContentContainer>
          <Title>{t('signUpRoyalPerksForFree')}</Title>
          <ItemsSection>
            <ItemsContainer>
              <ItemContainer>
                <ItemIconContainer>
                  <StyledIcon variant="bkCrown" />
                </ItemIconContainer>
                <ItemText>{t('earnCrowns')}</ItemText>
              </ItemContainer>
              <ItemContainer>
                <ItemIconContainer>
                  <StyledIcon variant="offer" />
                </ItemIconContainer>
                <ItemText>{t('exclusiveDeals')}</ItemText>
              </ItemContainer>
              <ItemContainer>
                <ItemIconContainer>
                  <StyledIcon variant="bkOrder" />
                </ItemIconContainer>
                <ItemText>{t('redeemFreeBK')}</ItemText>
              </ItemContainer>
            </ItemsContainer>
          </ItemsSection>
        </ContentContainer>
      </Container>
    </>
  );
};
